<template>
    <main class="container content">
        <router-link to="/calendar/month" class="d-flex">


            <picture class="m-0 d-flex">
                <source media="(max-width:648px)" srcset="../../../assets/images/calendar/calendar-banner-mob.gif">
                <img class="w-100" src="../../../assets/images/calendar/calendar-banner-des.gif" alt="">
            </picture>
        </router-link>
        <monthList :list="calendars" :currentMonthIndex="changeIndex" @changeSlide="goToSlide" />

        <section id="calendarSlider" ref="calendarSlider" class="product-details-img   position-relative ">
            <div class="product-details-l-img">
                <!-- Swiper -->
                <div v-if="calendars != null" class="swiper-container gallery-swiper mySwiper">
                    <div class="swiper_btns">
                        <div class=" swiper-gellery-prev">
                            <svg style="transform: rotate(180deg)" width="24" height="24" viewBox="0 0 24 24"
                                fill="#565656" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
                                    fill="#565656"></path>
                            </svg>
                            <span>ماه قبل</span>
                        </div>
                        <div class="d-flex align-items-center div-currentDate">
                            <span>امروز :</span>
                            <time :datetime="currentDateTime" @click="goToSlide(currentMonth)" v-if="currentDateTime"
                                class="currentDate">
                                {{ currentDateTime }}
                            </time>
                        </div>
                        <div class=" swiper-gellery-next">
                            <span>ماه بعد</span>

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="#565656"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
                                    fill="#565656"></path>
                            </svg>
                        </div>

                    </div>
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in calendars" :key="index" class="swiper-slide">
                            <picture>
                                <source media="(max-width:640px )" :srcset="item.image_mob">
                                <img loading="lazy" class="main" :alt="item.title" :src="item.image_des" />
                            </picture>
                        </div>
                    </div>
                </div>
                <div v-else class="h-100">
                    <div class="swiper-slide p-2"></div>
                </div>
            </div>


        </section>
    </main>
</template>
<script>
import monthList from "../components/calendar/monthList.vue";
import Swiper from "swiper/swiper-bundle";
import farvardin_des from "@/assets/images/calendar/des/1.jpg"
import ordibehesht_des from "@/assets/images/calendar/des/2.jpg"
import khordad_des from "@/assets/images/calendar/des/3.jpg"
import tir_des from "@/assets/images/calendar/des/4.jpg"
import mordad_des from "@/assets/images/calendar/des/5.jpg"
import shahrivar_des from "@/assets/images/calendar/des/6.jpg"
import mehr_des from "@/assets/images/calendar/des/7.jpg"
import aban_des from "@/assets/images/calendar/des/8.jpg"
import azar_des from "@/assets/images/calendar/des/9.jpg"
import dey_des from "@/assets/images/calendar/des/10.jpg"
import bahman_des from "@/assets/images/calendar/des/11.jpg"
import esfand_des from "@/assets/images/calendar/des/12.jpg"

import farvardin_mob from "@/assets/images/calendar/mobile/1.jpg"
import ordibehesht_mob from "@/assets/images/calendar/mobile/2.jpg"
import khordad_mob from "@/assets/images/calendar/mobile/3.jpg"
import tir_mob from "@/assets/images/calendar/mobile/4.jpg"
import mordad_mob from "@/assets/images/calendar/mobile/5.jpg"
import shahrivar_mob from "@/assets/images/calendar/mobile/6.jpg"
import mehr_mob from "@/assets/images/calendar/mobile/7.jpg"
import aban_mob from "@/assets/images/calendar/mobile/8.jpg"
import azar_mob from "@/assets/images/calendar/mobile/9.jpg"
import dey_mob from "@/assets/images/calendar/mobile/10.jpg"
import bahman_mob from "@/assets/images/calendar/mobile/11.jpg"
import esfand_mob from "@/assets/images/calendar/mobile/12.jpg"
import icon1 from "@/assets/images/calendar/icons/1.svg"
import icon2 from "@/assets/images/calendar/icons/2.svg"
import icon3 from "@/assets/images/calendar/icons/3.svg"
import icon4 from "@/assets/images/calendar/icons/4.svg"
import icon5 from "@/assets/images/calendar/icons/5.svg"
import icon6 from "@/assets/images/calendar/icons/6.svg"
import icon7 from "@/assets/images/calendar/icons/7.svg"
import icon8 from "@/assets/images/calendar/icons/8.svg"
import icon9 from "@/assets/images/calendar/icons/9.svg"
import icon10 from "@/assets/images/calendar/icons/10.svg"
import icon11 from "@/assets/images/calendar/icons/11.svg"
import icon12 from "@/assets/images/calendar/icons/12.svg"
export default {

    inject: ["mediaQueries"],
    data() {
        return {
            swiper: null,
            firstView: false,
            changeIndex: 0,
            calendars: [
                { image_mob: farvardin_mob, image_des: farvardin_des, icon: icon1, title: 'فروردین' },
                { image_mob: ordibehesht_mob, image_des: ordibehesht_des, icon: icon2, title: 'اردیبهشت' },
                { image_mob: khordad_mob, image_des: khordad_des, icon: icon3, title: 'خرداد' },
                { image_mob: tir_mob, image_des: tir_des, icon: icon4, title: 'تیر' },
                { image_mob: mordad_mob, image_des: mordad_des, icon: icon5, title: 'مرداد' },
                { image_mob: shahrivar_mob, image_des: shahrivar_des, icon: icon6, title: 'شهریور' },
                { image_mob: mehr_mob, image_des: mehr_des, icon: icon7, title: 'مهر' },
                { image_mob: aban_mob, image_des: aban_des, icon: icon8, title: 'آبان' },
                { image_mob: azar_mob, image_des: azar_des, icon: icon9, title: 'آذر' },
                { image_mob: dey_mob, image_des: dey_des, icon: icon10, title: 'دی' },
                { image_mob: bahman_mob, image_des: bahman_des, icon: icon11, title: 'بهمن' },
                { image_mob: esfand_mob, image_des: esfand_des, icon: icon12, title: 'اسفند' },

            ],

        };
    },
    components: { monthList },
    computed: {

        currentDateTime() {
            return this.$store.getters["front/getCurrentDateTime"];
        },
        // currentDay() {

        //     return this.$store.getters["front/getCurrentDay"];
        // },
        currentMonth() {
            this.changeIndex = this.$store.getters["front/getCurrentMonth"]
            return this.$store.getters["front/getCurrentMonth"];
        },
    },
    watch: {
        currentMonth(newMonth) {
            this.goToSlide(newMonth)
        },


    },
    mounted() {
        if (this.currentDateTime == null) {
            this.$store.dispatch("front/getCurrentDateTimeFromServer");
        }
        this.initialSwiper();
        this.$nextTick(() => {
            this.goToSlide(this.currentMonth)
        })
    },
    methods: {
        goToSlide(slideNumber) {
            this.changeIndex = slideNumber
            this.swiper.slideTo(slideNumber);
        },
        initialSwiper() {
            this.swiper = new Swiper(".product-details-img .swiper-container", {
                loop: false,

                slidesPerView: 1,
                speed: 1700,
                navigation: {
                    nextEl: ".product-details-img .swiper-gellery-next",
                    prevEl: ".product-details-img .swiper-gellery-prev",
                },
                on: {
                    slideChange: () => {

                        this.changeIndex = this.swiper.activeIndex;
                    }
                }
            });
        },
    },

};
</script>
<style scoped>
.currentDate {
    font-weight: 800;
    color: var(--color-theme);
    cursor: pointer;
}

.div-currentDate {
    font-size: 18px;
    font-weight: bold;
    color: var(--color-theme);
    gap: 5px;
}

img {
    width: 100%;
}

.content {
    margin-top: 40px;
}

.product-details-img {
    margin-top: 20px;
}

.swiper_btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
}

.filter-calendar {
    list-style-type: none;
    display: flex;
    gap: 16px;
    overflow: auto;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0;
    position: sticky;

    z-index: 100;
    padding-block: 10px;
    background-color: white;
}

.filter-calendar button {
    background-color: unset;
}

.filter-calendar button img {
    min-width: 80px;
}

.figcaption {
    font-size: 14px;
    margin-top: 10px;
    font-weight: 800;
}

@media only screen and (max-width:640px) {
    .currentDate {
        font-size: 14px;
    }

    .content {
        margin-top: 20px;
    }

    .filter-calendar {
        padding-block: 6px;
        margin-top: 10px;

    }

    .figcaption {
        font-size: 13px;
    }

    .product-details-img {
        margin-top: 10px;
    }

    .swiper_btns .swiper-gellery-prev svg,
    .swiper_btns .swiper-gellery-next svg {
        width: 18px;
        height: 18px;
    }

    .swiper_btns .swiper-gellery-prev span,
    .swiper_btns .swiper-gellery-next span {
        font-size: 14px;
    }
}
</style>
